var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetuserp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1436 2.70117C9.41887 2.70117 6.85416 3.96102 5.15935 6.02579L5.00936 5.42586C4.88938 4.96091 4.41943 4.67595 3.94948 4.79093C3.48453 4.91092 3.19956 5.38087 3.31455 5.85081L3.95448 8.39553C4.03947 8.6955 4.26945 8.94547 4.57941 9.01546C4.58941 9.12045 7.43409 8.82048 7.55908 8.82548C8.03902 8.78549 8.39399 8.36553 8.35399 7.88559C8.31399 7.40564 7.89904 7.05568 7.41409 7.09068L6.4692 7.17067C10.7337 1.86126 19.3978 4.87092 19.4128 11.7152C19.4128 15.7247 16.1531 18.9844 12.1436 18.9844C9.1339 18.9844 6.4742 17.1746 5.37432 14.3749C4.93437 13.315 3.34955 13.9399 3.7495 15.0148C7.48909 24.2088 21.0126 21.6391 21.1576 11.7152C21.1576 6.74571 17.113 2.70117 12.1436 2.70117Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.323 7.30078C11.143 7.30078 10.173 8.26078 10.173 9.45078V9.7508H10.123C9.15305 9.7508 8.37305 10.5308 8.37305 11.5008V13.9508C8.37305 14.9208 9.15305 15.7008 10.123 15.7008H14.523C15.493 15.7008 16.273 14.9208 16.273 13.9508V11.5008C16.273 10.5308 15.493 9.7508 14.523 9.7508H14.473V9.45078C14.473 8.26078 13.503 7.30078 12.323 7.30078Z",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3223 11.4492V12.6992",
    stroke: "#606060",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetuserp);
export default __webpack_public_path__ + "static/media/resetuserp.67cd98b6.svg";
export { ForwardRef as ReactComponent };